module.exports = __webpack_public_path__ + "static/media/2-ball.c3442414.png";